import { isNullable } from "@core/utils";
import { Factory, Form } from "../types/types";
import { factories } from "./factories";
import { toCamelCase, withoutPrefix } from "../utils/string";

export const transform = (form: Form): Record<string, any> => {
  return Object.keys(form).reduce((content, key: keyof Form) => {
    const factory = factories[key] as Factory<typeof key>;
    if (isNullable(factory)) return content;

    const value = form[key];
    if (isNullable(value)) return content;

    const property = withoutPrefix(key, "form");
    return Object.assign(content, { [toCamelCase(property)]: factory(value) });
  }, {});
};
